function Blank() {
  return (
    <section className="flex justify-center items-center h-screen ">
      <h1 className="font-bold text-5xl">Beral ASSONFACK</h1>
    </section>
  );
}
Blank.path = "/blank";
Blank.metadata = {
  title: " Beral ASSONFACK",
  description: "Loading...",
};
export default Blank;
